import React from "react";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { PageHero } from "@/components/layout/PageHero";
import { CtaBand } from "@/components/layout/CtaBand";
import { Section, SectionHeading } from "@/components/layout/Section";
import { MicroLabel } from "@/components/common/MicroLabel";
import { Reveal } from "@/components/common/Reveal";
import { ABOUT } from "@/content/pagesContent";

export default function ChiSiamo() {
  return (
    <SiteLayout>
      <PageHero
        testId="chi-siamo-page"
        micro={ABOUT.microLabel}
        title={ABOUT.title}
        description={ABOUT.description}
      />

      <Section id="about-story-section" tone="light">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-7">
            <Reveal>
              <SectionHeading microLabel="LA NOSTRA STORIA" title="Produzione su richiesta, fatta bene." />
            </Reveal>
            <div className="mt-6 space-y-5">
              {ABOUT.paragraphs.map((p, i) => (
                <Reveal key={i} delay={i * 0.06}>
                  <p className="max-w-[62ch] text-base leading-[1.7] text-muted-foreground">{p}</p>
                </Reveal>
              ))}
            </div>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <div className="grid grid-cols-2 gap-3">
                {ABOUT.stats.map((s) => (
                  <div key={s.label} className="rounded-xl border border-strato-gray-100 bg-strato-offwhite px-4 py-4">
                    <MicroLabel className="text-muted-foreground">{s.label}</MicroLabel>
                    <p className="mt-1 font-display text-lg font-medium text-strato-graphite">{s.value}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </Section>

      <Section id="about-values-section" tone="offwhite">
        <Reveal>
          <SectionHeading microLabel="VALORI" title="Cosa ci guida." />
        </Reveal>
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-3">
          {ABOUT.values.map((v, i) => (
            <Reveal key={v.title} delay={i * 0.05}>
              <div className="h-full rounded-2xl border border-strato-gray-100 bg-strato-white p-7">
                <MicroLabel className="text-strato-blue">{String(i + 1).padStart(2, "0")}</MicroLabel>
                <h3 className="mt-4 font-display text-xl font-medium text-strato-graphite">{v.title}</h3>
                <p className="mt-2 text-sm leading-[1.6] text-muted-foreground">{v.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>

      <CtaBand />
    </SiteLayout>
  );
}
